export const  isoDateToStr = (isoDateTmp) =>{
    const isoDateSec = Date.parse(isoDateTmp);
    if(isoDateSec){
        const isoDate = new Date(isoDateSec);
        const year = isoDate.getFullYear();
        const month = (isoDate.getMonth() + 1);
        const day = isoDate.getDate();
        const hour = isoDate.getHours().toString().padStart(2, '0');
        const min = isoDate.getMinutes().toString().padStart(2, '0')

        const dateText = `${year}年${month}月${day}日 ${hour}:${min}`;
        return dateText;
    }else{
        return "";
    }
};